import React from "react";

import { InputLegendProps } from './InputLegend.interface';
import styles from './InputLegend.module.css';

const InputLegend: React.FC<InputLegendProps> = ({
  legend,
  children,
  ...restProps
}) => {
  return (
    <label className={styles.field} {...restProps}>
      <legend className={styles.field__legend}>{legend}</legend>

      {children}
    </label>
  );
};

export default InputLegend;